<template>
  <div class="footer-txt">
    <el-text size="small" type="info" tag="p">页面由新民晚报技术部提供</el-text>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer-txt {
  margin: 15px auto;
}
</style>